import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useWorkshiftAPI() {
  const { languageRef, menuIdRef } = useStorage();

  function loadCurrentWorkshiftFromRemote() {
    const url = `/vbeta2/workshifts/current`;

    return axios({
      url,
      method: 'get',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Menu-Id': menuIdRef.current,
        'Accept-Language': languageRef.current?.tag,
      },
      responseType: 'json',
    });
  }

  return {
    loadCurrentWorkshiftFromRemote,
  };
}

export { useWorkshiftAPI };
